import React from 'react'
import { useDraggable } from '@dnd-kit/core'

export function Draggable(props) {
    const { attributes, listeners, setNodeRef, transform } = useDraggable(props)

    // Pendant le glissement, l'élément passe au premier plan (sinon il glisse sous les colonnes voisines).
    const style = transform ? {
        transform: `translate3d(${transform.x}px, ${transform.y}px, 0)`,
        position: 'relative',
        zIndex: 1300,
    } : undefined

    return (
        <div style={{ cursor: 'grab ', ...style }} ref={setNodeRef} {...listeners} {...attributes}>
            {props.children}
        </div>
    )
}